import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SideBarAdmin from '../../components/SideBarAdmin';
import { useAxios } from '../../utils/hook/useAxios';

const PAGE_SIZE = 20;

function AdminUsers() {
  const axios = useAxios();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get('/users')
      .then(({ data }) => {
        if (Array.isArray(data)) {
          setUsers(data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, []);

  const handleSearch = (val) => {
    setSearch(val);
    setPage(1);
  };
  const handleFilter = (val) => {
    setFilterStatus(val);
    setPage(1);
  };

  const filtered = users.filter((u) => {
    const matchStatus = filterStatus === 'all' || String(u.verified) === filterStatus;
    if (!matchStatus) return false;
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      u.firstName?.toLowerCase().includes(q) ||
      u.lastName?.toLowerCase().includes(q) ||
      u.email?.toLowerCase().includes(q) ||
      u.phoneNumber?.toLowerCase().includes(q) ||
      String(u.id).includes(q)
    );
  });

  const visible = filtered.slice(0, page * PAGE_SIZE);
  const hasMore = visible.length < filtered.length;

  return (
    <section className="bg-body-tertiary min-vh-100">
      <div className="container py-3 pb-5">
        <div className="row g-3">
          <div className="col-md-3 d-none d-md-block">
            <SideBarAdmin />
          </div>

          <div className="col-md-9">
            <div className="d-flex align-items-center gap-2 mb-3">
              <h5 className="mb-0 fw-bold flex-grow-1">
                <i className="bi bi-people-fill me-2 text-primary"></i>
                Utilisateurs
              </h5>
              <span className="badge bg-secondary-subtle text-secondary rounded-pill px-3">
                {filtered.length} résultat{filtered.length !== 1 ? 's' : ''}
              </span>
            </div>

            {/* Barre recherche + filtre */}
            <div className="row g-2 mb-3">
              <div className="col">
                <div className="input-group">
                  <span className="input-group-text bg-white">
                    <i className="bi bi-search text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Rechercher par nom, email, téléphone, ID…"
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  {search && (
                    <button className="btn btn-outline-secondary" onClick={() => handleSearch('')}>
                      <i className="bi bi-x"></i>
                    </button>
                  )}
                </div>
              </div>
              <div className="col-auto">
                <select
                  className="form-select"
                  value={filterStatus}
                  onChange={(e) => handleFilter(e.target.value)}
                >
                  <option value="all">Tous</option>
                  <option value="0">En attente</option>
                  <option value="1">Vérifiés</option>
                  <option value="2">Rejetés</option>
                </select>
              </div>
            </div>

            <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
              {isLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" />
                </div>
              ) : filtered.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <i className="bi bi-inbox" style={{ fontSize: 36 }}></i>
                  <p className="mt-2 mb-0">Aucun utilisateur trouvé</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0 align-middle">
                    <thead className="table-light">
                      <tr>
                        <th style={{ fontSize: 12 }}>Date</th>
                        <th style={{ fontSize: 12 }}>Utilisateur</th>
                        <th style={{ fontSize: 12 }} className="d-none d-sm-table-cell">
                          Email
                        </th>
                        <th style={{ fontSize: 12 }}>Statut</th>
                      </tr>
                    </thead>
                    <tbody>
                      {visible.map((item) => (
                        <tr key={item.id}>
                          <td style={{ fontSize: 12 }} className="text-muted">
                            {moment(item.createdAt).format('DD/MM/YY')}
                          </td>
                          <td>
                            <Link
                              to={`/admin/users/${item.id}`}
                              className="fw-semibold text-decoration-none"
                              style={{ fontSize: 13 }}
                            >
                              {item.firstName} {item.lastName}
                            </Link>
                          </td>
                          <td
                            className="d-none d-sm-table-cell text-muted"
                            style={{ fontSize: 12 }}
                          >
                            {item.email}
                          </td>
                          <td style={{ fontSize: 12 }}>
                            {String(item.verified) === '1' && (
                              <span className="badge bg-success-subtle text-success rounded-pill">
                                <i className="bi bi-check2-circle me-1"></i>Vérifié
                              </span>
                            )}
                            {String(item.verified) === '0' && (
                              <span className="badge bg-warning-subtle text-warning rounded-pill">
                                <i className="bi bi-clock-history me-1"></i>En attente
                              </span>
                            )}
                            {String(item.verified) === '2' && (
                              <span className="badge bg-danger-subtle text-danger rounded-pill">
                                <i className="bi bi-x-circle me-1"></i>Rejeté
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {hasMore && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-outline-primary rounded-pill px-4"
                  onClick={() => setPage((p) => p + 1)}
                >
                  <i className="bi bi-chevron-down me-2"></i>
                  Charger plus ({filtered.length - visible.length} restant
                  {filtered.length - visible.length > 1 ? 's' : ''})
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminUsers;
